import { render, staticRenderFns } from "./Gem.vue?vue&type=template&id=1ab2290c&scoped=true&"
import script from "./Gem.vue?vue&type=script&lang=ts&"
export * from "./Gem.vue?vue&type=script&lang=ts&"
import style0 from "./Gem.vue?vue&type=style&index=0&id=1ab2290c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2290c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
